<template>
    <div class="container tile">
        <div class="bs-docs-grid">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <h1>Session Timeout</h1>
                    <div v-if="content" v-html="content"></div>
                    <p v-else>Your session has expired. You must start over.</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { useMainStore } from "@/mainStore";
import { asyncComputed } from "@vueuse/core";
export default defineComponent({
    setup() {
        const content = asyncComputed(() => {
            try {
                const mainStore = useMainStore();
                const tenantData = mainStore.tenantData;
                return tenantData.customSessionExpiredHtml;
            } catch {
                return null;
            }
        }, null);

        return {
            content,
        };
    },
});
</script>
